import './accordion.scss';
import accordion from './accordion.js';

export default accordion;